import { useState, useEffect, useRef, useCallback } from "react";

/* ─── SVG ICON SYSTEM ─────────────────────────────────────────── */
const Icon = ({ name, size = 16, color = "currentColor", strokeWidth = 1.5, style: s }) => {
  const paths = {
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>,
    clock:    <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></>,
    map:      <><path d="M12 21C12 21 4 13.5 4 8.5a8 8 0 0 1 16 0C20 13.5 12 21 12 21z" /><circle cx="12" cy="8.5" r="2.5" /></>,
    user:     <><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" /></>,
    ticket:   <><path d="M2 9a1 1 0 0 1 0-2V5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 0 0 2v2a1 1 0 0 1 0 2v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 0 0-2V9z" /><line x1="9" y1="4" x2="9" y2="20" strokeDasharray="2 2" /></>,
    cart:     <><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" /></>,
    star:     <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></>,
    search:   <><circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35" /></>,
    close:    <><path d="M18 6 6 18M6 6l12 12" /></>,
    chevron:  <path d="m6 9 6 6 6-6" />,
    arrow:    <path d="M5 12h14M12 5l7 7-7 7" />,
    check:    <path d="M20 6 9 17l-5-5" />,
    heart:    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />,
    music:    <><path d="M9 18V5l12-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="18" cy="16" r="3" /></>,
    mic:      <><rect x="9" y="2" width="6" height="12" rx="3" /><path d="M19 10a7 7 0 0 1-14 0M12 19v3M8 22h8" /></>,
    film:     <><rect x="2" y="2" width="20" height="20" rx="2.18" /><line x1="7" y1="2" x2="7" y2="22" /><line x1="17" y1="2" x2="17" y2="22" /><line x1="2" y1="12" x2="22" y2="12" /><line x1="2" y1="7" x2="7" y2="7" /><line x1="2" y1="17" x2="7" y2="17" /><line x1="17" y1="17" x2="22" y2="17" /><line x1="17" y1="7" x2="22" y2="7" /></>,
    laugh:    <><circle cx="12" cy="12" r="10" /><path d="M8 14s1.5 2 4 2 4-2 4-2" /><line x1="9" y1="9" x2="9.01" y2="9" /><line x1="15" y1="9" x2="15.01" y2="9" /></>,
    palette:  <><circle cx="12" cy="12" r="10" /><path d="M12 2a10 10 0 0 1 10 10c0 2-1 3-3 3h-1a2 2 0 0 0 0 4 2 2 0 0 1 0 4 10 10 0 0 1-6-18" /></>,
    cpu:      <><rect x="4" y="4" width="16" height="16" rx="2" /><rect x="9" y="9" width="6" height="6" /><line x1="9" y1="1" x2="9" y2="4" /><line x1="15" y1="1" x2="15" y2="4" /><line x1="9" y1="20" x2="9" y2="23" /><line x1="15" y1="20" x2="15" y2="23" /><line x1="20" y1="9" x2="23" y2="9" /><line x1="20" y1="14" x2="23" y2="14" /><line x1="1" y1="9" x2="4" y2="9" /><line x1="1" y1="14" x2="4" y2="14" /></>,
    run:      <><circle cx="13" cy="4" r="2" /><path d="M7.7 10.7 10 8l3 3 2-2.5L17 11" /><path d="M4 20l3-5 3 1 4-7" /></>,
    minus:    <line x1="5" y1="12" x2="19" y2="12" />,
    plus:     <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>,
    trash:    <><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6M14 11v6" /><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /></>,
    credit:   <><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></>,
    lock:     <><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>,
    fire:     <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />,
    globe:    <><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></>,
    sparkle:  <><path d="M12 3v1M12 20v1M4.22 4.22l.71.71M19.07 19.07l.71.71M3 12h1M20 12h1M4.22 19.78l.71-.71M19.07 4.93l.71-.71" /><circle cx="12" cy="12" r="4" /></>,
    zap:      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
    award:    <><circle cx="12" cy="8" r="6" /><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" /></>,
    share:    <><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></>,
    filter:   <><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" style={s}>
      {paths[name]}
    </svg>
  );
};

/* ─── DATA ────────────────────────────────────────────────────── */
const EVENTS = [
  { id:1, category:"Music", hot:true, title:"Neon Frequencies", subtitle:"Electronic · Techno · Ambient", artist:"DJ Kollective & Friends", date:"Sat, 24 May 2026", time:"22:00–06:00", venue:"The Warehouse", city:"Rotterdam", rating:4.9, reviews:312, image:"https://images.unsplash.com/photo-1571324610943-5d8f9b5c3b15?w=900&q=80", seatsLeft:142, capacity:1500, description:"An immersive eight-hour journey through electronic music. Three stages, curated sound design, and a light installation by Studio Drift that transforms the industrial space into something otherworldly. The lineup spans international headliners and local Rotterdam talent across techno, bass, and ambient.", lineup:["DJ Kollective","Recondite","Paula Temple","Mor Elian"], amenities:["3 Stages","Food Village","Cloakroom","Accessible"], tickets:[{type:"Early Bird",desc:"Limited allocation · Standing",price:35,available:28},{type:"General Admission",desc:"Standing floor access",price:49,available:114},{type:"VIP Floor",desc:"Elevated platform + 2 drink tokens",price:110,available:18},{type:"VIP Lounge",desc:"Private lounge · Open bar · Meet & greet",price:195,available:6}] },
  { id:2, category:"Classical", title:"Symphonie en Lumière", subtitle:"Classical · Contemporary", artist:"Rotterdam Philharmonic Orchestra", date:"Sat, 7 Jun 2026", time:"20:00–22:30", venue:"De Doelen", city:"Rotterdam", rating:4.8, reviews:204, image:"https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=900&q=80", seatsLeft:38, capacity:2200, description:"Mahler's Fifth Symphony paired with a responsive light installation by Iris van der Berg, projected across the concert hall. The Rotterdam Philharmonic performs under conductor Lorenzo Viotti in an evening where architecture, music, and light become inseparable.", lineup:["Rotterdam Philharmonic","Lorenzo Viotti (conductor)","Iris van der Berg (light artist)"], amenities:["Champagne Bar","Programme Booklet","Accessible","Parking"], tickets:[{type:"Balcony",desc:"Upper level · Excellent acoustics",price:55,available:22},{type:"Stalls",desc:"Main floor seating",price:85,available:12},{type:"Premium Stalls",desc:"Central floor · Best acoustic position",price:140,available:4}] },
  { id:3, category:"Comedy", title:"Comedy Riot", subtitle:"Stand-up · Improv", artist:"Six Headlining Acts", date:"Sat, 31 May 2026", time:"19:30–22:00", venue:"Laughing Basement", city:"Utrecht", rating:4.7, reviews:178, image:"https://images.unsplash.com/photo-1527224538127-2104bb71c51b?w=900&q=80", seatsLeft:73, capacity:350, description:"Six of Europe's most talked-about comedians on one stage. Hosted by Jasper Vos, the evening moves between sharp stand-up sets and spontaneous crowd improv. Intimate venue, full bar, deliberately no phones allowed.", lineup:["Jasper Vos","Caitlin Hoffman","Mo Traore","Eline de Wit","Karl Byrne","Zara Osei"], amenities:["Full Bar","No Phone Policy","Intimate Venue","Merchandise"], tickets:[{type:"Standard",desc:"General seating",price:32,available:63},{type:"Front Row",desc:"First three rows · Includes drink",price:55,available:10}] },
  { id:4, category:"Art", title:"Art & Chaos", subtitle:"Contemporary · Installation", artist:"Group Exhibition — 15 Artists", date:"14–28 Jun 2026", time:"11:00–20:00", venue:"Museum Boijmans", city:"Rotterdam", rating:4.6, reviews:91, image:"https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=900&q=80", seatsLeft:210, capacity:800, description:"Fifteen emerging European artists challenge the language of contemporary art across 4,000 square metres. Themes of entropy, control, and digital identity run throughout. Open daily, guided tours every Saturday at 14:00.", lineup:["Mila Voss","Ibrahim Al-Rashid","Yuki Tanaka","Clara Mendes","…and 11 more"], amenities:["Guided Tours Sat","Café","Artist Talks","Accessible"], tickets:[{type:"Day Pass",desc:"Single day entry",price:18,available:180},{type:"Season Pass",desc:"Unlimited access for full run",price:42,available:30}] },
  { id:5, category:"Music", title:"House of Bass", subtitle:"Bass Music · Drum & Bass", artist:"International Lineup", date:"Sun, 21 Jun 2026", time:"23:00–07:00", venue:"Shelter ADE", city:"Amsterdam", rating:4.8, reviews:267, image:"https://images.unsplash.com/photo-1598387993441-a364f854cfda?w=900&q=80", seatsLeft:56, capacity:600, description:"Underground bass music in its most concentrated form. This intimate venue guarantees a physical experience built around custom subwoofer arrays and a crowd that doesn't surface until sunrise.", lineup:["Skeptical","Dillinja","Alix Perez","Ivy Lab"], amenities:["Void Sound System","Outdoor Area","24h Licence","Cloakroom"], tickets:[{type:"Early Entry",desc:"23:00–01:00 window",price:22,available:24},{type:"Full Night",desc:"23:00–07:00",price:38,available:32}] },
  { id:6, category:"Tech", title:"Tech Summit NL", subtitle:"AI · Climate Tech · Deep Tech", artist:"50+ International Speakers", date:"Thu–Fri, 4–5 Jun 2026", time:"09:00–18:00", venue:"RAI Amsterdam", city:"Amsterdam", rating:4.5, reviews:543, image:"https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=900&q=80", seatsLeft:892, capacity:3000, description:"Two days with the brightest minds in European technology. Keynotes, workshops, and structured networking across AI, climate tech, and deep tech verticals. The partner expo features 80+ startups.", lineup:["Fei-Fei Li","Demis Hassabis","Tabitha Goldstaub","Pieter Abbeel"], amenities:["80+ Expo Stands","Workshop Tracks","Networking Lounge","Catering"], tickets:[{type:"Virtual Pass",desc:"Full livestream access",price:79,available:500},{type:"Workshop Day",desc:"One day · Hands-on sessions",price:149,available:180},{type:"Conference Pass",desc:"Both days · All sessions + expo",price:299,available:212},{type:"Executive Pass",desc:"Roundtables + speaker dinners",price:599,available:18}] },
  { id:7, category:"Sport", title:"Rotterdam Marathon", subtitle:"Road Running · 42.2 km", artist:"Elite & Amateur Fields", date:"Sun, 12 Apr 2026", time:"09:00 start", venue:"Coolsingel", city:"Rotterdam", rating:4.9, reviews:1284, image:"https://images.unsplash.com/photo-1530549387789-4c1017266635?w=900&q=80", seatsLeft:340, capacity:14000, description:"One of Europe's fastest marathon courses winds through Rotterdam's iconic architecture. The flat route along the Maas and across the Erasmusbrug is a PB machine. Elite prize money of €150,000.", lineup:["Elite Field TBA","Wheelchair Category","Amateur Categories","Corporate Teams"], amenities:["Chip Timing","Finisher Medal","Pasta Dinner Sat","Baggage Drop"], tickets:[{type:"Marathon 42.2 km",desc:"Full distance · All categories",price:85,available:280},{type:"Half Marathon",desc:"21.1 km · Same route first half",price:55,available:60}] },
  { id:8, category:"Film", title:"Rooftop Cinema", subtitle:"Open-Air Screenings", artist:"Curated Programme — 8 Films", date:"Every Fri & Sat, Jun 2026", time:"21:30", venue:"Fenix Loodsen Rooftop", city:"Rotterdam", rating:4.7, reviews:156, image:"https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=900&q=80", seatsLeft:88, capacity:200, description:"Eight curated films screened under Rotterdam's open sky across June. Deck chairs, blankets, and a curated food menu. The programme spans arthouse, a restored 35mm classic, and one secret screening.", lineup:["Programme announced monthly","35mm Restoration Night","Secret Screening","Director Q&A ×2"], amenities:["Deck Chairs","Food & Bar","Blankets Provided","No Rain Cancellations"], tickets:[{type:"Single Screening",desc:"One evening",price:22,available:64},{type:"June Pass",desc:"All 8 screenings",price:120,available:24}] },
];

const CATEGORIES = ["All","Music","Classical","Comedy","Art","Tech","Sport","Film"];
const CAT_ICON = { All:"sparkle", Music:"music", Classical:"mic", Comedy:"laugh", Art:"palette", Tech:"cpu", Sport:"run", Film:"film" };

const fmtPrice = n => `€${n.toFixed(2)}`;
const genRef = () => "VVD-" + Math.random().toString(36).slice(2,8).toUpperCase();

/* ─── STYLES ──────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --bg:#08080d;--s1:#101016;--s2:#18181f;--s3:#20202a;
  --b1:rgba(255,255,255,0.06);--b2:rgba(255,255,255,0.10);--b3:rgba(255,255,255,0.16);
  --ink:#f0f0fa;--ink2:#9898b4; --ink3:#ffffff !important;
  --red:#e8365d;--red-lo:rgba(232,54,93,0.1);--red-md:rgba(232,54,93,0.22);
  --green:#10b981;--amber:#f59e0b;
  --font:'Quicksand',sans-serif;
  --r8:8px;--r12:12px;--r16:16px;--r20:20px;--r24:24px;
}
html{scroll-behavior:smooth}
body{font-family:var(--font);background:var(--bg);color:var(--ink);min-height:100vh;overflow-x:hidden;-webkit-font-smoothing:antialiased}
::-webkit-scrollbar{width:3px}::-webkit-scrollbar-track{background:var(--bg)}::-webkit-scrollbar-thumb{background:var(--s3);border-radius:2px}

/* GRAIN */
.grain{position:fixed;inset:0;pointer-events:none;z-index:999;opacity:.03;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E")}

/* NAV */
nav{position:sticky;top:0;z-index:90;height:58px;padding:0 24px;display:flex;align-items:center;gap:0;
  border-bottom:1px solid var(--b1);background:rgba(8,8,13,.85);backdrop-filter:blur(20px) saturate(1.4)}
.logo{display:flex;align-items:center;gap:9px;margin-right:auto;cursor:pointer}
.logomark{width:28px;height:28px;border-radius:7px;background:var(--red);display:grid;place-items:center;flex-shrink:0}
.wordmark{font-size:1rem;font-weight:700;color:var(--ink);letter-spacing:-.2px}
.nav-acts{display:flex;align-items:center;gap:7px}
.nbtn{display:flex;align-items:center;gap:6px;height:34px;padding:0 13px;border-radius:var(--r8);
  border:1px solid var(--b2);background:var(--s2);font-family:var(--font);font-size:.78rem;font-weight:600;color:var(--ink2);
  cursor:pointer;transition:background .18s,border-color .18s,color .18s;white-space:nowrap}
.nbtn:hover{background:var(--s3);border-color:var(--b3);color:var(--ink)}
.nbtn.p{background:var(--red);border-color:var(--red);color:#fff}
.nbtn.p:hover{background:#cf2e50;border-color:#cf2e50}
.cbadge{background:var(--ink);color:var(--bg);width:16px;height:16px;border-radius:50%;font-size:.6rem;font-weight:700;display:grid;place-items:center;animation:pop .25s cubic-bezier(.175,.885,.32,1.275)}
@keyframes pop{from{transform:scale(0)}to{transform:scale(1)}}

/* HERO */
.hero{position:relative;height:clamp(500px,78vh,760px);display:flex;flex-direction:column;justify-content:flex-end;overflow:hidden;cursor:pointer}
.hero-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:transform 7s ease}
.hero:hover .hero-img{transform:scale(1.04)}
.hero-veil{position:absolute;inset:0;background:linear-gradient(to top,var(--bg) 0%,rgba(8,8,13,.65) 45%,rgba(8,8,13,.15) 100%)}
.hero-body{position:relative;z-index:2;padding:0 24px 44px;max-width:660px}
.hero-pill{display:inline-flex;align-items:center;gap:7px;background:var(--red);border-radius:6px;padding:4px 10px;font-size:.68rem;font-weight:700;letter-spacing:.8px;text-transform:uppercase;color:#fff;margin-bottom:14px}
.hero-h1{font-size:clamp(1.9rem,6vw,4.2rem);font-weight:700;line-height:1.07;letter-spacing:-1.5px;margin-bottom:10px}
.hero-p{font-size:clamp(.84rem,1.4vw,.95rem);color:var(--ink2);font-weight:500;line-height:1.65;margin-bottom:24px;max-width:430px}
.hero-row{display:flex;gap:9px;flex-wrap:wrap}
.btn{display:inline-flex;align-items:center;gap:7px;height:42px;padding:0 20px;border-radius:var(--r8);border:none;font-family:var(--font);font-size:.85rem;font-weight:700;cursor:pointer;transition:all .22s;letter-spacing:.15px}
.btn-r{background:var(--red);color:#fff}
.btn-r:hover{background:#cf2e50;transform:translateY(-1px);box-shadow:0 8px 22px rgba(232,54,93,.32)}
.btn-g{background:rgba(255,255,255,.08);color:var(--ink);border:1px solid var(--b2)}
.btn-g:hover{background:rgba(255,255,255,.13)}
.hero-stats{display:flex;gap:22px;margin-top:28px}
.hst-n{font-size:1.45rem;font-weight:700;line-height:1}
.hst-l{font-size:.68rem;font-weight:600;color:var(--ink3);margin-top:2px;letter-spacing:.2px}

/* TICKER */
.ticker{background:var(--red);overflow:hidden;padding:9px 0}
.ticker-t{display:flex;animation:tick 26s linear infinite;white-space:nowrap}
.ticker-i{display:flex;align-items:center;gap:10px;padding:0 28px;font-size:.74rem;font-weight:700;color:rgba(255,255,255,.85);letter-spacing:.5px;text-transform:uppercase;flex-shrink:0}
.t-sep{width:3px;height:3px;background:rgba(255,255,255,.35);border-radius:50%}
@keyframes tick{from{transform:translateX(0)}to{transform:translateX(-50%)}}

/* SECTION */
.sec{padding:64px 24px;max-width:1180px;margin:0 auto}
.sec-lbl{display:flex;align-items:center;gap:7px;font-size:.68rem;font-weight:700;letter-spacing:1.4px;text-transform:uppercase;color:var(--ink3);margin-bottom:8px}
.sec-h2{font-size:clamp(1.45rem,3.5vw,2.2rem);font-weight:700;letter-spacing:-.7px;margin-bottom:6px}
.sec-p{color:var(--ink2);font-size:.88rem;font-weight:500;line-height:1.6}

/* FEATURED GRID */
.fg{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:auto auto;gap:18px;margin-bottom:72px}
@media(max-width:640px){.fg{grid-template-columns:1fr}}
.fc{position:relative;border-radius:var(--r20);overflow:hidden;cursor:pointer;transition:transform .3s cubic-bezier(.25,.46,.45,.94)}
.fc:hover{transform:scale(1.012)}
.fc.wide{grid-column:1/-1;height:340px}
.fc.tall{height:280px}
.fc img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:transform .55s ease;display:block}
.fc:hover img{transform:scale(1.06)}
.fc-veil{position:absolute;inset:0;background:linear-gradient(to top,rgba(8,8,13,.95) 0%,rgba(8,8,13,.25) 70%,transparent 100%)}
.fc-body{position:absolute;bottom:0;left:0;right:0;padding:22px}
.fc-tag{display:inline-flex;align-items:center;gap:5px;background:var(--red);border-radius:5px;padding:3px 9px;font-size:.65rem;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:#fff;margin-bottom:9px}
.fc-h{font-size:clamp(1.1rem,2.5vw,1.7rem);font-weight:700;letter-spacing:-.4px;line-height:1.15;margin-bottom:3px}
.fc-m{font-size:.78rem;color:rgba(255,255,255,.6);font-weight:500;margin-bottom:14px}
.fc-btn{display:inline-flex;align-items:center;gap:7px;background:#fff;color:var(--bg);border-radius:7px;padding:9px 16px;font-family:var(--font);font-size:.79rem;font-weight:700;border:none;cursor:pointer;transition:all .2s}
.fc-btn:hover{background:rgba(255,255,255,.88);transform:translateX(2px)}

/* SEARCH */
.srch{position:relative;margin-bottom:24px}
.srch-in{width:100%;height:46px;background:var(--s2);border:1px solid var(--b2);border-radius:var(--r12);
  padding:0 100px 0 44px;font-family:var(--font);font-size:.88rem;font-weight:500;color:var(--ink);outline:none;transition:border-color .2s}
.srch-in::placeholder{color:var(--ink3)}
.srch-in:focus{border-color:var(--b3)}
.srch-ico{position:absolute;left:14px;top:50%;transform:translateY(-50%);pointer-events:none}
.srch-kbd{position:absolute;right:12px;top:50%;transform:translateY(-50%);background:var(--s3);border:1px solid var(--b2);border-radius:5px;padding:2px 7px;font-size:.65rem;font-weight:700;color:var(--ink3);font-family:monospace}

/* CATS */
.cats{display:flex;gap:7px;flex-wrap:wrap;margin-bottom:32px}
.cat{display:flex;align-items:center;gap:5px;height:32px;padding:0 12px;border-radius:7px;
  border:1px solid var(--b2);background:var(--s2);font-family:var(--font);font-size:.76rem;font-weight:600;color:var(--ink2);cursor:pointer;transition:all .2s}
.cat:hover{color:var(--ink);border-color:var(--b3)}
.cat.on{background:var(--red-lo);border-color:var(--red-md);color:var(--ink)}

/* GRID */
.grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:18px}

/* CARD */
.ecard{background:var(--s1);border:1px solid var(--b1);border-radius:var(--r20);overflow:hidden;cursor:pointer;position:relative;
  transition:transform .3s cubic-bezier(.25,.46,.45,.94),border-color .25s,box-shadow .3s;animation:rise .4s both}
@keyframes rise{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
.ecard:hover{transform:translateY(-5px);border-color:var(--b2);box-shadow:0 18px 44px rgba(0,0,0,.5)}
.ec-img{position:relative;height:185px;overflow:hidden}
.ec-img img{width:100%;height:100%;object-fit:cover;transition:transform .5s ease;display:block}
.ecard:hover .ec-img img{transform:scale(1.06)}
.ec-ov{position:absolute;inset:0;background:linear-gradient(to bottom,transparent 50%,var(--s1) 100%)}
.ec-badges{position:absolute;top:11px;left:11px;display:flex;gap:5px}
.bdg{display:inline-flex;align-items:center;gap:4px;padding:3px 8px;border-radius:5px;font-size:.64rem;font-weight:700;letter-spacing:.4px}
.bdg-cat{background:rgba(8,8,13,.72);backdrop-filter:blur(8px);color:#fff;border:1px solid rgba(255,255,255,.1)}
.bdg-hot{background:var(--red);color:#fff}
.bdg-low{background:rgba(245,158,11,.12);border:1px solid rgba(245,158,11,.28);color:var(--amber)}
.ec-wish{position:absolute;top:11px;right:11px;width:30px;height:30px;border-radius:7px;
  background:rgba(8,8,13,.65);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.1);
  display:grid;place-items:center;cursor:pointer;transition:all .2s}
.ec-wish:hover,.ec-wish.on{background:rgba(232,54,93,.18);border-color:var(--red)}
.ec-body{padding:16px 16px 14px}
.ec-meta{display:flex;align-items:center;gap:4px;font-size:.7rem;font-weight:600;color:var(--ink3);margin-bottom:7px}
.mdot{width:2px;height:2px;background:var(--ink3);border-radius:50%}
.ec-title{font-size:1.01rem;font-weight:700;letter-spacing:-.25px;margin-bottom:2px}
.ec-sub{font-size:.74rem;color:var(--ink3);font-weight:500;margin-bottom:12px}
.ec-foot{display:flex;align-items:center;justify-content:space-between}
.ec-price{font-size:.78rem;font-weight:700;color:var(--ink2)}
.ec-price b{font-size:1.05rem;color:var(--ink)}
.ec-rating{display:flex;align-items:center;gap:3px;font-size:.74rem;font-weight:700;color:var(--amber)}
.ec-rating span{color:var(--ink3);font-weight:500}
.avbar{margin-top:11px}
.avtrack{height:2.5px;background:var(--s3);border-radius:2px}
.avfill{height:2.5px;border-radius:2px;transition:width .8s ease}
.avlbl{display:flex;justify-content:space-between;margin-top:4px;font-size:.65rem;font-weight:600;color:var(--ink3)}

/* MODAL */
.moverlay{position:fixed;inset:0;z-index:99999999;background:rgba(4,4,8,.88);backdrop-filter:blur(18px);
  display:flex;align-items:flex-end;justify-content:center;padding:0;animation:fi .22s}
@media(min-width:640px){.moverlay{align-items:center;padding:24px}}
@keyframes fi{from{opacity:0}to{opacity:1}}
.modal{position:relative;width:100%;max-width:700px;max-height:92dvh;overflow-y:auto;
  background:var(--s1);border:1px solid var(--b2);border-radius:var(--r24) var(--r24) 0 0;
  animation:su .36s cubic-bezier(.175,.885,.32,1.1)}
@media(min-width:640px){.modal{border-radius:var(--r24)}}
@keyframes su{from{transform:translateY(30px);opacity:0}to{transform:translateY(0);opacity:1}}
.m-imgwrap{position:relative;height:230px;flex-shrink:0}
.m-imgwrap img{width:100%;height:100%;object-fit:cover;display:block;border-radius:var(--r24) var(--r24) 0 0}
.m-imgov{position:absolute;inset:0;background:linear-gradient(to bottom,transparent 35%,var(--s1) 100%);border-radius:var(--r24) var(--r24) 0 0}
.m-close{position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:7px;
  background:rgba(8,8,13,.62);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.1);
  color:var(--ink2);cursor:pointer;display:grid;place-items:center;transition:all .2s}
.m-close:hover{background:rgba(232,54,93,.2);border-color:var(--red);color:var(--ink)}
.m-body{padding:22px 22px 30px}
.m-eyebrow{display:flex;align-items:center;gap:5px;font-size:.67rem;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--ink3);margin-bottom:7px}
.m-title{font-size:clamp(1.35rem,4vw,1.9rem);font-weight:700;letter-spacing:-.6px;margin-bottom:3px}
.m-sub{font-size:.83rem;color:var(--ink2);font-weight:500;margin-bottom:8px}
.m-stars{display:flex;align-items:center;gap:5px;font-size:.78rem;font-weight:700;color:var(--amber);margin-bottom:20px}
.m-stars span{color:var(--ink3);font-weight:500}
.ig{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:22px}
@media(max-width:420px){.ig{grid-template-columns:1fr}}
.ic{background:var(--s2);border:1px solid var(--b1);border-radius:var(--r12);padding:13px}
.ic-lbl{font-size:.64rem;font-weight:700;letter-spacing:.8px;text-transform:uppercase;color:var(--ink3);margin-bottom:4px;display:flex;align-items:center;gap:4px}
.ic-val{font-size:.9rem;font-weight:700}
.m-desc{font-size:.86rem;color:var(--ink2);line-height:1.72;font-weight:500;margin-bottom:22px}
.lu-title{font-size:.66rem;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--ink3);margin-bottom:10px}
.lu-list{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:20px}
.lu-chip{background:var(--s2);border:1px solid var(--b2);border-radius:7px;padding:5px 11px;font-size:.78rem;font-weight:600}
.am-list{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:22px}
.am-item{display:flex;align-items:center;gap:4px;font-size:.75rem;font-weight:600;color:var(--ink2);background:var(--s2);border:1px solid var(--b1);border-radius:6px;padding:4px 9px}
.mdiv{height:1px;background:var(--b1);margin:20px 0}
.tsl{font-size:.67rem;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--ink3);margin-bottom:11px}
.topts{display:flex;flex-direction:column;gap:8px;margin-bottom:20px}
.topt{display:flex;align-items:center;justify-content:space-between;
  background:var(--s2);border:1px solid var(--b1);border-radius:var(--r12);padding:13px 15px;cursor:pointer;transition:all .2s}
.topt:hover{border-color:var(--b2)}
.topt.sel{border-color:rgba(232,54,93,.38);background:rgba(232,54,93,.07)}
.topt-l{display:flex;align-items:center;gap:11px}
.trad{width:15px;height:15px;border-radius:50%;border:1.5px solid var(--b2);display:grid;place-items:center;flex-shrink:0;transition:border-color .2s}
.topt.sel .trad{border-color:var(--red)}
.trad-d{width:7px;height:7px;border-radius:50%;background:var(--red);transform:scale(0);transition:transform .2s}
.topt.sel .trad-d{transform:scale(1)}
.t-name{font-size:.88rem;font-weight:700;margin-bottom:1px}
.t-desc{font-size:.72rem;color:var(--ink3);font-weight:500}
.t-avail{font-size:.66rem;font-weight:600;color:var(--green);margin-top:2px;display:flex;align-items:center;gap:3px}
.t-price{font-size:1.05rem;font-weight:700}
.qty-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px}
.qty-lbl{font-size:.86rem;font-weight:700}
.qty-sub{font-size:.72rem;color:var(--ink3);font-weight:500;margin-top:1px}
.qty-ctrl{display:flex;align-items:center;gap:13px}
.qbtn{width:34px;height:34px;border-radius:8px;border:1px solid var(--b2);background:var(--s2);color:var(--ink);display:grid;place-items:center;cursor:pointer;transition:all .18s}
.qbtn:hover{background:var(--s3);border-color:var(--b3)}
.qbtn:disabled{opacity:.3;cursor:not-allowed}
.qnum{font-size:1.1rem;font-weight:700;min-width:18px;text-align:center}
.addbtn{width:100%;height:48px;border-radius:var(--r12);border:none;background:var(--red);color:#fff;
  font-family:var(--font);font-size:.92rem;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:9px;transition:all .22s}
.addbtn:hover{background:#cf2e50;transform:translateY(-1px);box-shadow:0 9px 26px rgba(232,54,93,.36)}
.secure{display:flex;align-items:center;justify-content:center;gap:5px;margin-top:10px;font-size:.7rem;font-weight:600;color:var(--ink3)}

/* CART DRAWER */
.cov{position:fixed;inset:0;z-index:300;background:rgba(4,4,8,.75);backdrop-filter:blur(12px);animation:fi .2s}
.cdrawer{position:fixed;top:0;right:0;bottom:0;width:min(420px,100vw);background:var(--s1);border-left:1px solid var(--b2);
  z-index:301;display:flex;flex-direction:column;animation:csi .3s cubic-bezier(.25,.46,.45,.94)}
@keyframes csi{from{transform:translateX(100%)}to{transform:translateX(0)}}
.ch{padding:0 18px;height:58px;border-bottom:1px solid var(--b1);display:flex;align-items:center;justify-content:space-between;flex-shrink:0}
.ch-title{font-size:.95rem;font-weight:700;display:flex;align-items:center;gap:9px}
.ch-cnt{background:var(--s3);border-radius:5px;padding:2px 7px;font-size:.72rem;font-weight:700;color:var(--ink2)}
.cx{width:30px;height:30px;border-radius:7px;border:1px solid var(--b2);background:var(--s2);color:var(--ink2);cursor:pointer;display:grid;place-items:center;transition:all .18s}
.cx:hover{color:var(--ink);border-color:var(--b3)}
.citems{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:9px}
.cempty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:11px;color:var(--ink3)}
.cempty-ico{width:48px;height:48px;border-radius:12px;background:var(--s2);border:1px solid var(--b1);display:grid;place-items:center}
.cempty-t{font-size:.85rem;font-weight:600;color:var(--ink2)}
.cempty-s{font-size:.75rem;font-weight:500}
.citem{display:flex;gap:11px;background:var(--s2);border:1px solid var(--b1);border-radius:var(--r12);padding:13px;animation:rise .22s both}
.ci-img{width:54px;height:54px;border-radius:8px;object-fit:cover;flex-shrink:0}
.ci-inf{flex:1;min-width:0}
.ci-n{font-size:.83rem;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:2px}
.ci-t{font-size:.7rem;color:var(--ink3);font-weight:600;margin-bottom:5px}
.ci-ft{display:flex;align-items:center}
.ci-p{font-size:.88rem;font-weight:700}
.ciqc{display:flex;align-items:center;gap:5px;margin-left:auto}
.ciqb{width:22px;height:22px;border-radius:5px;border:1px solid var(--b2);background:var(--s3);color:var(--ink);display:grid;place-items:center;cursor:pointer;transition:all .15s}
.ciqb:hover{background:var(--s1);border-color:var(--b3)}
.ciqn{font-size:.77rem;font-weight:700;min-width:12px;text-align:center}
.cirm{color:var(--ink3);cursor:pointer;display:grid;place-items:center;margin-left:6px;transition:color .18s}
.cirm:hover{color:var(--red)}
.cfoot{padding:14px;border-top:1px solid var(--b1);flex-shrink:0}
.crow{display:flex;justify-content:space-between;font-size:.8rem;font-weight:600;color:var(--ink3);margin-bottom:5px}
.ctotal{display:flex;justify-content:space-between;align-items:center;padding:12px 0;border-top:1px solid var(--b1);margin-bottom:12px}
.ctlbl{font-size:.88rem;font-weight:700}
.ctval{font-size:1.35rem;font-weight:700}
.cobtn{width:100%;height:46px;border-radius:var(--r12);border:none;background:var(--red);color:#fff;
  font-family:var(--font);font-size:.9rem;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:7px;transition:all .2s}
.cobtn:hover{background:#cf2e50;transform:translateY(-1px);box-shadow:0 7px 20px rgba(232,54,93,.3)}

/* CHECKOUT */
.cowrap{max-width:940px;margin:0 auto;padding:44px 24px;display:grid;grid-template-columns:1fr 360px;gap:30px;align-items:start}
@media(max-width:768px){.cowrap{grid-template-columns:1fr}}
.cobk{display:inline-flex;align-items:center;gap:7px;font-size:.8rem;font-weight:700;color:var(--ink3);background:none;border:none;cursor:pointer;font-family:var(--font);padding:0;margin-bottom:24px;transition:color .18s}
.cobk:hover{color:var(--ink)}
.coh1{font-size:1.7rem;font-weight:700;letter-spacing:-.5px;margin-bottom:5px}
.cop{font-size:.84rem;color:var(--ink2);font-weight:500;margin-bottom:32px}
.cosec{margin-bottom:26px}
.cosec-t{font-size:.65rem;font-weight:700;letter-spacing:1.2px;text-transform:uppercase;color:var(--ink3);padding-bottom:9px;border-bottom:1px solid var(--b1);margin-bottom:14px;display:flex;align-items:center;gap:7px}
.fg2{display:grid;grid-template-columns:1fr 1fr;gap:11px}
.fg2 .full{grid-column:1/-1}
.flbl{font-size:.7rem;font-weight:700;letter-spacing:.3px;color:var(--ink2);margin-bottom:5px;display:block}
.fin{height:42px;background:var(--s2);border:1px solid var(--b2);border-radius:var(--r8);padding:0 13px;
  font-family:var(--font);font-size:.86rem;font-weight:500;color:var(--ink);outline:none;width:100%;transition:border-color .18s,box-shadow .18s}
.fin:focus{border-color:rgba(255,255,255,.2);box-shadow:0 0 0 3px rgba(232,54,93,.1)}
.fin::placeholder{color:var(--ink3)}
.paybtn{width:100%;height:50px;border-radius:var(--r12);border:none;background:var(--red);color:#fff;
  font-family:var(--font);font-size:.95rem;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:9px;transition:all .22s;margin-top:26px}
.paybtn:hover{background:#cf2e50;transform:translateY(-1px);box-shadow:0 10px 28px rgba(232,54,93,.36)}

/* ORDER SIDEBAR */
.osidebar{background:var(--s1);border:1px solid var(--b2);border-radius:var(--r20);padding:20px;position:sticky;top:80px}
.os-t{font-size:.88rem;font-weight:700;margin-bottom:16px}
.os-item{display:flex;gap:11px;margin-bottom:13px}
.os-img{width:50px;height:50px;border-radius:8px;object-fit:cover;flex-shrink:0}
.os-n{font-size:.8rem;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.os-ty{font-size:.69rem;color:var(--ink3);font-weight:600;margin-top:2px}
.os-pr{font-size:.82rem;font-weight:700;margin-top:3px}
.os-div{height:1px;background:var(--b1);margin:12px 0}
.os-row{display:flex;justify-content:space-between;font-size:.79rem;font-weight:600;color:var(--ink3);margin-bottom:6px}
.os-tot{display:flex;justify-content:space-between;font-size:1.02rem;font-weight:700;margin-top:9px}

/* SUCCESS */
.swrap{min-height:calc(100vh - 58px);display:flex;align-items:center;justify-content:center;padding:40px 20px}
.scard{max-width:420px;width:100%;background:var(--s1);border:1px solid var(--b2);border-radius:var(--r24);padding:44px 32px;text-align:center}
.sico{width:68px;height:68px;border-radius:18px;background:rgba(16,185,129,.1);border:1px solid rgba(16,185,129,.22);display:grid;place-items:center;margin:0 auto 22px;animation:sp .5s cubic-bezier(.175,.885,.32,1.275)}
@keyframes sp{from{transform:scale(0) rotate(-15deg);opacity:0}to{transform:scale(1) rotate(0);opacity:1}}
.s-h1{font-size:1.7rem;font-weight:700;letter-spacing:-.4px;margin-bottom:9px}
.s-p{font-size:.86rem;color:var(--ink2);font-weight:500;line-height:1.7;margin-bottom:28px}
.s-ref{background:var(--s2);border:1px solid var(--b1);border-radius:var(--r12);padding:13px;margin-bottom:24px}
.s-rl{font-size:.64rem;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--ink3);margin-bottom:3px}
.s-rv{font-size:1.02rem;font-weight:700;letter-spacing:.8px}
.s-bk{width:100%;height:44px;border-radius:var(--r12);border:1px solid var(--b2);background:var(--s2);color:var(--ink);font-family:var(--font);font-size:.86rem;font-weight:700;cursor:pointer;transition:all .2s}
.s-bk:hover{background:var(--s3);border-color:var(--b3)}

/* RESPONSIVE */
@media(max-width:540px){
  nav{padding:0 14px}
  .sec{padding:44px 14px}
  .hero-body{padding:0 14px 32px}
  .cowrap{padding:28px 14px}
}
`;

/* ─── APP ─────────────────────────────────────────────────────── */
export default function App() {
  const [page, setPage] = useState("home");
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [modal, setModal] = useState(null);
  const [cat, setCat] = useState("All");
  const [search, setSearch] = useState("");
  const [selTkt, setSelTkt] = useState(0);
  const [qty, setQty] = useState(1);
  const [wish, setWish] = useState(new Set());
  const [form, setForm] = useState({ name:"", email:"", phone:"", card:"", expiry:"", cvv:"" });
  const [ref] = useState(genRef);

  const filtered = EVENTS.filter(e => {
    const mc = cat === "All" || e.category === cat;
    const ms = !search || e.title.toLowerCase().includes(search.toLowerCase()) || e.artist.toLowerCase().includes(search.toLowerCase()) || e.city.toLowerCase().includes(search.toLowerCase());
    return mc && ms;
  });

  const cartTotal = cart.reduce((s, i) => s + i.price * i.qty, 0);
  const cartCount = cart.reduce((s, i) => s + i.qty, 0);
  const fee = cartTotal * 0.075;

  const openModal = ev => { setModal(ev); setSelTkt(0); setQty(1); };
  const toggleWish = id => setWish(p => { const s = new Set(p); s.has(id) ? s.delete(id) : s.add(id); return s; });

  const addToCart = () => {
    const t = modal.tickets[selTkt];
    const key = `${modal.id}::${t.type}`;
    setCart(prev => {
      const ex = prev.find(i => i.key === key);
      if (ex) return prev.map(i => i.key === key ? { ...i, qty: i.qty + qty } : i);
      return [...prev, { key, id: modal.id, name: modal.title, type: t.type, price: t.price, qty, img: modal.image }];
    });
    setModal(null); setCartOpen(true);
  };

  const updQty = (key, d) => setCart(p => p.map(i => i.key === key ? { ...i, qty: Math.max(1, i.qty + d) } : i));
  const remItem = key => setCart(p => p.filter(i => i.key !== key));
  const handlePay = e => { e.preventDefault(); setPage("success"); setCart([]); };

  /* SUCCESS */
  if (page === "success") return (
    <>
      <style>{CSS}</style>
      <div className="grain" />
      <nav>
        <div className="logo" onClick={() => setPage("home")}>
          <div className="logomark"><Icon name="ticket" size={14} color="white" strokeWidth={2} /></div>
          <span className="wordmark">Vivid</span>
        </div>
      </nav>
      <div className="swrap">
        <div className="scard">
          <div className="sico"><Icon name="check" size={28} color="#10b981" strokeWidth={2.5} /></div>
          <h1 className="s-h1">You're confirmed</h1>
          <p className="s-p">Your tickets are booked and a confirmation has been sent to your email address. We'll see you there.</p>
          <div className="s-ref">
            <div className="s-rl">Booking reference</div>
            <div className="s-rv">{ref}</div>
          </div>
          <button className="s-bk" onClick={() => setPage("home")}>Back to events</button>
        </div>
      </div>
    </>
  );

  /* CHECKOUT */
  if (page === "checkout") return (
    <>
      <style>{CSS}</style>
      <div className="grain" />
      <nav>
        <div className="logo" onClick={() => setPage("home")}>
          <div className="logomark"><Icon name="ticket" size={14} color="white" strokeWidth={2} /></div>
          <span className="wordmark">Vivid</span>
        </div>
      </nav>
      <div className="cowrap">
        <div>
          <button className="cobk" onClick={() => setPage("home")}>
            <Icon name="arrow" size={13} style={{ transform:"rotate(180deg)" }} /> Back to events
          </button>
          <h1 className="coh1">Checkout</h1>
          <p className="cop">Complete your details to secure your tickets.</p>
          <form onSubmit={handlePay}>
            <div className="cosec">
              <div className="cosec-t"><Icon name="user" size={12} color="var(--ink3)" /> Personal details</div>
              <div className="fg2">
                <div className="full" style={{ display:"flex",flexDirection:"column",gap:4 }}>
                  <label className="flbl">Full name</label>
                  <input required className="fin" placeholder="Jan de Vries" value={form.name} onChange={e => setForm(f=>({...f,name:e.target.value}))} />
                </div>
                <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
                  <label className="flbl">Email address</label>
                  <input required type="email" className="fin" placeholder="jan@example.com" value={form.email} onChange={e => setForm(f=>({...f,email:e.target.value}))} />
                </div>
                <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
                  <label className="flbl">Phone number</label>
                  <input className="fin" placeholder="+31 6 0000 0000" value={form.phone} onChange={e => setForm(f=>({...f,phone:e.target.value}))} />
                </div>
              </div>
            </div>
            <div className="cosec">
              <div className="cosec-t"><Icon name="credit" size={12} color="var(--ink3)" /> Payment details</div>
              <div className="fg2">
                <div className="full" style={{ display:"flex",flexDirection:"column",gap:4 }}>
                  <label className="flbl">Card number</label>
                  <input required className="fin" placeholder="1234 5678 9012 3456" value={form.card} onChange={e => setForm(f=>({...f,card:e.target.value}))} />
                </div>
                <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
                  <label className="flbl">Expiry date</label>
                  <input required className="fin" placeholder="MM / YY" value={form.expiry} onChange={e => setForm(f=>({...f,expiry:e.target.value}))} />
                </div>
                <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
                  <label className="flbl">CVV</label>
                  <input required className="fin" placeholder="•••" maxLength={4} value={form.cvv} onChange={e => setForm(f=>({...f,cvv:e.target.value}))} />
                </div>
              </div>
            </div>
            <button type="submit" className="paybtn">
              <Icon name="lock" size={15} color="white" strokeWidth={2} />
              Pay {fmtPrice(cartTotal + fee)} securely
            </button>
            <div className="secure" style={{ marginTop:12 }}>
              <Icon name="lock" size={11} color="var(--ink3)" />
              256-bit SSL · PCI DSS compliant · Instant confirmation
            </div>
          </form>
        </div>
        <div className="osidebar">
          <div className="os-t">Order summary</div>
          {cart.map(i => (
            <div key={i.key} className="os-item">
              <img src={i.img} alt={i.name} className="os-img" />
              <div style={{ flex:1, minWidth:0 }}>
                <div className="os-n">{i.name}</div>
                <div className="os-ty">{i.type} · ×{i.qty}</div>
                <div className="os-pr">{fmtPrice(i.price * i.qty)}</div>
              </div>
            </div>
          ))}
          <div className="os-div" />
          <div className="os-row"><span>Subtotal</span><span>{fmtPrice(cartTotal)}</span></div>
          <div className="os-row"><span>Booking fee (7.5%)</span><span>{fmtPrice(fee)}</span></div>
          <div className="os-tot"><span>Total</span><span>{fmtPrice(cartTotal + fee)}</span></div>
        </div>
      </div>
    </>
  );

  /* HOME */
  return (
    <>
      <style>{CSS}</style>
      <div className="grain" />

      <nav>
        <div className="logo">
          <div className="logomark"><Icon name="ticket" size={14} color="white" strokeWidth={2} /></div>
          <span className="wordmark">Vivid</span>
        </div>
        <div className="nav-acts">
          <button className="nbtn" style={{ display:"flex" }}>
            <Icon name="globe" size={12} color="var(--ink3)" /> NL
          </button>
          <button className="nbtn" onClick={() => setCartOpen(true)}>
            <Icon name="ticket" size={12} color="var(--ink2)" />
            Cart
            {cartCount > 0 && <span className="cbadge" key={cartCount}>{cartCount}</span>}
          </button>
          <button className="nbtn p">
            <Icon name="user" size={12} color="white" /> Sign in
          </button>
        </div>
      </nav>

      {/* HERO */}
      <div className="hero" onClick={() => openModal(EVENTS[0])}>
        <img src={EVENTS[0].image} alt={EVENTS[0].title} className="hero-img" />
        <div className="hero-veil" />
        <div className="hero-body">
          <div className="hero-pill"><Icon name="fire" size={10} color="white" strokeWidth={2} /> Featured tonight</div>
          <h1 className="hero-h1">{EVENTS[0].title}</h1>
          <p className="hero-p">{EVENTS[0].venue} · {EVENTS[0].city} · {EVENTS[0].date}</p>
          <div className="hero-row" onClick={e => e.stopPropagation()}>
            <button className="btn btn-r" onClick={() => openModal(EVENTS[0])}>
              Get tickets <Icon name="arrow" size={13} color="white" />
            </button>
            <button className="btn btn-g" onClick={() => toggleWish(EVENTS[0].id)}>
              <Icon name="heart" size={13} color={wish.has(EVENTS[0].id) ? "#e8365d" : "currentColor"} strokeWidth={wish.has(EVENTS[0].id) ? 0 : 1.5} style={{ fill: wish.has(EVENTS[0].id) ? "#e8365d" : "none" }} />
              {wish.has(EVENTS[0].id) ? "Saved" : "Save"}
            </button>
          </div>
          <div className="hero-stats">
            <div><div className="hst-n">1,200+</div><div className="hst-l">Events</div></div>
            <div><div className="hst-n">85 k</div><div className="hst-l">Tickets sold</div></div>
            <div><div className="hst-n">4.8</div><div className="hst-l">Avg rating</div></div>
          </div>
        </div>
      </div>

      {/* TICKER */}
      <div className="ticker">
        <div className="ticker-t">
          {[...EVENTS,...EVENTS].map((e,i) => (
            <span key={i} className="ticker-i">
              <Icon name={CAT_ICON[e.category]||"sparkle"} size={11} color="rgba(255,255,255,.7)" />
              {e.title} — {e.city}
              <span className="t-sep" />
            </span>
          ))}
        </div>
      </div>

      {/* FEATURED GRID */}
      <div className="sec" style={{ paddingBottom:0 }}>
        <div className="sec-lbl"><Icon name="zap" size={11} color="var(--ink3)" /> Editors' picks</div>
        <h2 className="sec-h2" style={{ marginBottom:22 }}>Not to be missed</h2>
        <div className="fg">
          {/* wide card */}
          <div className="fc wide" onClick={() => openModal(EVENTS[0])}>
            <img src={EVENTS[0].image} alt={EVENTS[0].title} />
            <div className="fc-veil" />
            <div className="fc-body">
              <div className="fc-tag"><Icon name="fire" size={9} color="white" strokeWidth={2} /> Selling fast</div>
              <div className="fc-h">{EVENTS[0].title}</div>
              <div className="fc-m">{EVENTS[0].date} · {EVENTS[0].venue}, {EVENTS[0].city}</div>
              <button className="fc-btn">From {fmtPrice(Math.min(...EVENTS[0].tickets.map(t=>t.price)))} <Icon name="arrow" size={12} color="var(--bg)" /></button>
            </div>
          </div>
          {[EVENTS[1], EVENTS[7]].map(ev => (
            <div key={ev.id} className="fc tall" onClick={() => openModal(ev)}>
              <img src={ev.image} alt={ev.title} />
              <div className="fc-veil" />
              <div className="fc-body">
                <div className="fc-tag"><Icon name={CAT_ICON[ev.category]} size={9} color="white" /> {ev.category}</div>
                <div className="fc-h">{ev.title}</div>
                <div className="fc-m">{ev.date}</div>
                <button className="fc-btn">From {fmtPrice(Math.min(...ev.tickets.map(t=>t.price)))} <Icon name="arrow" size={12} color="var(--bg)" /></button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ALL EVENTS */}
      <div className="sec">
        <div className="sec-lbl"><Icon name="calendar" size={11} color="var(--ink3)" /> Browse</div>
        <h2 className="sec-h2">All events</h2>
        <p className="sec-p" style={{ marginBottom:24 }}>Concerts, exhibitions, sport, and more across the Netherlands.</p>

        <div className="srch">
          <span className="srch-ico"><Icon name="search" size={15} color="var(--ink3)" /></span>
          <input className="srch-in" placeholder="Search events, artists, cities…" value={search} onChange={e => setSearch(e.target.value)} />
          <span className="srch-kbd">⌘K</span>
        </div>

        <div className="cats">
          {CATEGORIES.map(c => (
            <button key={c} className={`cat${cat===c?" on":""}`} onClick={() => setCat(c)}>
              <Icon name={CAT_ICON[c]||"sparkle"} size={12} color={cat===c?"var(--ink)":"var(--ink3)"} />
              {c}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div style={{ textAlign:"center", padding:"56px 20px", color:"var(--ink3)" }}>
            <Icon name="search" size={34} color="var(--ink3)" />
            <div style={{ marginTop:10, fontWeight:600, fontSize:".88rem", color:"var(--ink2)" }}>No events found</div>
            <div style={{ fontSize:".78rem", marginTop:3 }}>Try adjusting your search or category filter</div>
          </div>
        ) : (
          <div className="grid">
            {filtered.map((ev, i) => {
              const min = Math.min(...ev.tickets.map(t=>t.price));
              const pct = (ev.seatsLeft / ev.capacity) * 100;
              const low = ev.seatsLeft < 80;
              return (
                <div key={ev.id} className="ecard" style={{ animationDelay:`${i*.055}s` }} onClick={() => openModal(ev)}>
                  <div className="ec-img">
                    <img src={ev.image} alt={ev.title} />
                    <div className="ec-ov" />
                    <div className="ec-badges">
                      <span className="bdg bdg-cat"><Icon name={CAT_ICON[ev.category]} size={9} color="white" />{ev.category}</span>
                      {ev.hot && <span className="bdg bdg-hot"><Icon name="fire" size={8} color="white" strokeWidth={2} />Hot</span>}
                      {low && !ev.hot && <span className="bdg bdg-low"><Icon name="zap" size={8} color="var(--amber)" strokeWidth={2} />Low seats</span>}
                    </div>
                    <div className={`ec-wish${wish.has(ev.id)?" on":""}`} onClick={e=>{e.stopPropagation();toggleWish(ev.id);}}>
                      <Icon name="heart" size={13} color={wish.has(ev.id)?"#e8365d":"var(--ink2)"} strokeWidth={wish.has(ev.id)?0:1.5} style={{ fill:wish.has(ev.id)?"#e8365d":"none" }} />
                    </div>
                  </div>
                  <div className="ec-body">
                    <div className="ec-meta">
                      <Icon name="calendar" size={10} color="var(--ink3)" />
                      {ev.date}
                      <span className="mdot" />
                      <Icon name="map" size={10} color="var(--ink3)" />
                      {ev.city}
                    </div>
                    <div className="ec-title">{ev.title}</div>
                    <div className="ec-sub">{ev.subtitle}</div>
                    <div className="ec-foot">
                      <div className="ec-price">from <b>{fmtPrice(min)}</b></div>
                      <div className="ec-rating">
                        <Icon name="star" size={11} color="var(--amber)" strokeWidth={0} style={{ fill:"var(--amber)" }} />
                        {ev.rating} <span>({ev.reviews})</span>
                      </div>
                    </div>
                    <div className="avbar">
                      <div className="avtrack"><div className="avfill" style={{ width:`${pct}%`, background:pct<15?"var(--amber)":"var(--green)" }} /></div>
                      <div className="avlbl">
                        <span style={{ color:pct<15?"var(--amber)":undefined }}>{ev.seatsLeft} remaining</span>
                        <span>{ev.capacity.toLocaleString()} cap</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* MODAL */}
      {modal && (
        <div className="moverlay" onClick={() => setModal(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="m-imgwrap">
              <img src={modal.image} alt={modal.title} />
              <div className="m-imgov" />
              <button className="m-close" onClick={() => setModal(null)}><Icon name="close" size={14} color="var(--ink2)" /></button>
            </div>
            <div className="m-body">
              <div className="m-eyebrow"><Icon name={CAT_ICON[modal.category]} size={11} color="var(--ink3)" />{modal.category} · {modal.city}</div>
              <div className="m-title">{modal.title}</div>
              <div className="m-sub">{modal.artist}</div>
              <div className="m-stars">
                <Icon name="star" size={12} color="var(--amber)" strokeWidth={0} style={{ fill:"var(--amber)" }} />
                {modal.rating} <span>({modal.reviews} reviews)</span>
              </div>

              <div className="ig">
                <div className="ic"><div className="ic-lbl"><Icon name="calendar" size={10} color="var(--ink3)" />Date</div><div className="ic-val">{modal.date}</div></div>
                <div className="ic"><div className="ic-lbl"><Icon name="clock" size={10} color="var(--ink3)" />Time</div><div className="ic-val">{modal.time}</div></div>
                <div className="ic"><div className="ic-lbl"><Icon name="map" size={10} color="var(--ink3)" />Venue</div><div className="ic-val">{modal.venue}</div></div>
                <div className="ic"><div className="ic-lbl"><Icon name="ticket" size={10} color="var(--ink3)" />Availability</div><div className="ic-val" style={{ color:modal.seatsLeft<80?"var(--amber)":"var(--green)" }}>{modal.seatsLeft} of {modal.capacity}</div></div>
              </div>

              <p className="m-desc">{modal.description}</p>

              <div className="lu-title">Lineup / Speakers</div>
              <div className="lu-list">{modal.lineup.map((n,i)=><span key={i} className="lu-chip">{n}</span>)}</div>

              <div className="lu-title" style={{ marginBottom:10 }}>What's included</div>
              <div className="am-list">{modal.amenities.map((a,i)=><span key={i} className="am-item"><Icon name="check" size={10} color="var(--green)" strokeWidth={2.5} />{a}</span>)}</div>

              <div className="mdiv" />
              <div className="tsl">Select ticket type</div>
              <div className="topts">
                {modal.tickets.map((t,i) => (
                  <div key={i} className={`topt${selTkt===i?" sel":""}`} onClick={() => setSelTkt(i)}>
                    <div className="topt-l">
                      <div className="trad"><div className="trad-d" /></div>
                      <div>
                        <div className="t-name">{t.type}</div>
                        <div className="t-desc">{t.desc}</div>
                        <div className="t-avail">
                          <div style={{ width:5,height:5,borderRadius:"50%",background:t.available<20?"var(--amber)":"var(--green)" }} />
                          {t.available} available
                        </div>
                      </div>
                    </div>
                    <div className="t-price">{fmtPrice(t.price)}</div>
                  </div>
                ))}
              </div>

              <div className="qty-row">
                <div>
                  <div className="qty-lbl">Quantity</div>
                  <div className="qty-sub">Max 10 per order</div>
                </div>
                <div className="qty-ctrl">
                  <button className="qbtn" onClick={() => setQty(q=>Math.max(1,q-1))} disabled={qty<=1}><Icon name="minus" size={13} /></button>
                  <span className="qnum">{qty}</span>
                  <button className="qbtn" onClick={() => setQty(q=>Math.min(10,q+1))} disabled={qty>=10}><Icon name="plus" size={13} /></button>
                </div>
              </div>

              <button className="addbtn" onClick={addToCart}>
                <Icon name="cart" size={15} color="white" strokeWidth={2} />
                Add to cart — {fmtPrice(modal.tickets[selTkt].price * qty)}
              </button>
              <div className="secure">
                <Icon name="lock" size={11} color="var(--ink3)" />
                Free cancellation within 24 h · Secure checkout
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CART */}
      {cartOpen && (
        <>
          <div className="cov" onClick={() => setCartOpen(false)} />
          <div className="cdrawer">
            <div className="ch">
              <div className="ch-title">
                <Icon name="ticket" size={14} color="var(--ink2)" />
                Your cart
                {cartCount > 0 && <span className="ch-cnt">{cartCount} item{cartCount!==1?"s":""}</span>}
              </div>
              <button className="cx" onClick={() => setCartOpen(false)}><Icon name="close" size={13} color="var(--ink2)" /></button>
            </div>

            {cart.length === 0 ? (
              <div className="cempty">
                <div className="cempty-ico"><Icon name="ticket" size={20} color="var(--ink3)" /></div>
                <div className="cempty-t">Your cart is empty</div>
                <div className="cempty-s">Find an event and add tickets to get started</div>
              </div>
            ) : (
              <div className="citems">
                {cart.map(item => (
                  <div key={item.key} className="citem">
                    <img src={item.img} alt={item.name} className="ci-img" />
                    <div className="ci-inf">
                      <div className="ci-n">{item.name}</div>
                      <div className="ci-t">{item.type}</div>
                      <div className="ci-ft">
                        <div className="ci-p">{fmtPrice(item.price * item.qty)}</div>
                        <div className="ciqc">
                          <button className="ciqb" onClick={() => updQty(item.key,-1)}><Icon name="minus" size={9} /></button>
                          <span className="ciqn">{item.qty}</span>
                          <button className="ciqb" onClick={() => updQty(item.key,1)}><Icon name="plus" size={9} /></button>
                        </div>
                        <div className="cirm" onClick={() => remItem(item.key)}><Icon name="trash" size={13} /></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {cart.length > 0 && (
              <div className="cfoot">
                <div className="crow"><span>Subtotal</span><span>{fmtPrice(cartTotal)}</span></div>
                <div className="crow"><span>Booking fee (7.5%)</span><span>{fmtPrice(fee)}</span></div>
                <div className="ctotal">
                  <span className="ctlbl">Total</span>
                  <span className="ctval">{fmtPrice(cartTotal + fee)}</span>
                </div>
                <button className="cobtn" onClick={() => { setCartOpen(false); setPage("checkout"); }}>
                  Proceed to checkout <Icon name="arrow" size={13} color="white" />
                </button>
                <div className="secure" style={{ marginTop:10 }}>
                  <Icon name="lock" size={11} color="var(--ink3)" />
                  Secure · Encrypted · PCI compliant
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}